import "../../App.css";
import "../../styles/login.css";
import React from "react";
import Sidebar from "../Sidebar";
import UserTab from "../UserTab";

function ReporteEnDesarrollo(props) {
  const { nombre } = props;
  return (
    <div className="App">
      <Sidebar tipo="3" />
      <br />
      <UserTab nombre={nombre || "Reporte"} />
      <div id="login">
        <div className="container" style={{ textAlign: "center", padding: 40 }}>
          <h3>En desarrollo</h3>
          <p>Este reporte todavía no está disponible.</p>
        </div>
      </div>
    </div>
  );
}

export default ReporteEnDesarrollo;
